import React, { useEffect, useRef, useState } from "react";
import { useGLTF } from "@react-three/drei";
import { useFrame } from "@react-three/fiber";

export function Model({ color, ...props }) {
  const { scene } = useGLTF("/glasses.glb");

  const modelRef = useRef();

  const [scale, setScale] = useState([25, 25, 25]);
  const [position, setPosition] = useState([0, 0, 0]);

  useFrame(() => {
    if (modelRef.current) {
      modelRef.current.rotation.y += 0.01;
    }
  });

  useEffect(() => {
    scene.traverse((child) => {
      if (child.isMesh && child.material) {
        child.material.color.set(color);
      }
    });
  }, [color, scene]);

  return (
    <primitive
      ref={modelRef}
      object={scene}
      scale={scale}
      position={position}
      {...props}
    />
  );
}

useGLTF.preload("/glasses.glb");